<template>
  <div
    class="tool"
    :class="{'tool--dragging': dragging}"
    :data-type="type"
  >
    <!-- {{ icon }} -->
    <img
      :src="`/img/icon-${ icon }.svg`"
      alt=""
      class="tool__icon"
    >
    <!-- <font-awesome-icon :icon="icon" class="tool__icon"></font-awesome-icon> -->
    <div class="tool__text">
      {{ label }}
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .tool {
    // margin: 0.75rem 0.25rem;
    background-color: white;
    // border: solid 1px;
    border-color: rgba(255,255,255,0.2);
    cursor: grab;
    transition: all 0.3s;
    padding: 0.75rem;
    // margin-bottom: 0.75rem;
    // border-radius: 3px;
    padding: 20px 0;
    text-align: center;
    min-width: 90px;
    color: black;
    position: relative;
    // &--dragging{
    //   background-color: red;
    // }

    & + & {
      &::before{
        content: '';
        width: 55px;
        border-top: solid 1px rgba(black, 0.2);
        display: block;
        position: absolute;
        top: 0;
        left: 20px;
        right: 20px;
      }
    }

    &__icon{
      // font-size: 2.8rem;
      margin-bottom: 0.75rem;
    }
    &:hover &__icon{
      opacity: 0.2;
    }

    &:hover{
      &::before {
        opacity: 0.2;
      }
      color: rgba(black,0.2);
      border-top-color: rgba(black,0.2);
    }

    img{
      pointer-events: none;
    }

    &__text{
      text-transform: uppercase;
      font-family: "Open Sans";
      font-size: 0.75rem;
      text-align: center;
    }
  }
</style>
<script>

export default {
  name: 'Tool',
  props: ['label', 'icon', 'type'],
  data() {
    return {
      dragging: false,
    };
  },
  methods: {
    click() {
      // this.dragging = true
    },
    drag(event) {
      // EventBus.$emit('drag:start', {type: this.type})
    },
    dragend(event) {
      // console.log('Dragend', event.target)
      // this.dragging = false
      // EventBus.$emit('drag:stop', {type: this.type})
    },
  },
};
</script>
